
  (function () {
    'use strict';

    if (customElements.get('core-air-lifestyle')) return;

    class LifestyleStorySlider extends HTMLElement {
      connectedCallback() {
        this.sticky = this.querySelector('.story-slider__sticky');
        this.track = this.querySelector('.story-slider__track');
        this.cards = Array.prototype.slice.call(this.querySelectorAll('.story-slider__card'));
        this.progressFill = this.querySelector('[data-slider-progress]');
        this.prevBtn = this.querySelector('[data-slider-previous]');
        this.nextBtn = this.querySelector('[data-slider-next]');
        this.loop = this.querySelector('[data-slider-loop="true"]') !== null;
        this.enableDesktopScroll = this.dataset.enableDesktopScroll === 'true';

        if (!this.track || this.cards.length === 0) return;

        this._total = 0;
        this._maxX = 0;
        this._p = 0;
        this._ticking = false;
        this._currentX = 0;
        this._targetX = 0;

        this._tick = this.tick.bind(this);
        this._requestTick = this.requestTick.bind(this);
        this._onResize = this.onResize.bind(this);
        this._onTrackScroll = this.onTrackScroll.bind(this);
        this._applyMode = this.applyMode.bind(this);
        this._onPrev = this.goPrev.bind(this);
        this._onNext = this.goNext.bind(this);

        if (this.prevBtn) this.prevBtn.addEventListener('click', this._onPrev);
        if (this.nextBtn) this.nextBtn.addEventListener('click', this._onNext);
        this.track.addEventListener('scroll', this._onTrackScroll, { passive: true });

        window.addEventListener('scroll', this._requestTick, { passive: true });
        window.addEventListener('resize', this._onResize, { passive: true });
        window.addEventListener('load', this._onResize, { passive: true });

        this.mq = window.matchMedia('(min-width: 750px)');
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (this.mq.addEventListener) this.mq.addEventListener('change', this._applyMode);
        if (this.reduce.addEventListener) this.reduce.addEventListener('change', this._applyMode);

        this.applyMode();
        this.updateProgress(0);
      }

      disconnectedCallback() {
        if (this.prevBtn) this.prevBtn.removeEventListener('click', this._onPrev);
        if (this.nextBtn) this.nextBtn.removeEventListener('click', this._onNext);
        if (this.track) this.track.removeEventListener('scroll', this._onTrackScroll);
        window.removeEventListener('scroll', this._requestTick);
        window.removeEventListener('resize', this._onResize);
        window.removeEventListener('load', this._onResize);
        if (this.mq && this.mq.removeEventListener) this.mq.removeEventListener('change', this._applyMode);
        if (this.reduce && this.reduce.removeEventListener) this.reduce.removeEventListener('change', this._applyMode);
      }

      get scrollMode() {
        return this.classList.contains('story-slider__stage--scroll');
      }

      applyMode() {
        var wantScroll = this.enableDesktopScroll && this.mq.matches && this.cards.length > 1 && !this.reduce.matches;
        if (wantScroll) {
          this.enterScroll();
        } else {
          this.exitScroll();
        }
      }

      enterScroll() {
        if (this.scrollMode) return;
        this.classList.add('story-slider__stage--scroll');
        var self = this;
        // Let the sticky/tall layout settle, then measure and paint once.
        requestAnimationFrame(function () {
          self.measure();
          self.tick();
        });
      }

      exitScroll() {
        if (this.scrollMode) {
          this.classList.remove('story-slider__stage--scroll');
        }
        this.track.style.transform = '';
        this._currentX = 0;
        this._targetX = 0;
        // Reflect the native-scroll position on the progress bar instead.
        this.onTrackScroll();
      }

      measure() {
        this._total = Math.max(0, this.offsetHeight - this.sticky.offsetHeight);
        this._maxX = Math.max(0, this.track.scrollWidth - this.sticky.clientWidth);
        // Snap lerp state on resize to avoid stale drift
        this._currentX = this._targetX;
      }

      requestTick() {
        if (!this.scrollMode || this._ticking) return;
        this._ticking = true;
        requestAnimationFrame(this._tick);
      }

      tick() {
        this._ticking = false;
        if (!this.scrollMode) return;

        var rect = this.getBoundingClientRect();
        var p = this._total > 0 ? -rect.top / this._total : 0;
        if (p < 0) p = 0;
        else if (p > 1) p = 1;
        this._p = p;

        this._targetX = -(p * this._maxX);
        // Lerp toward target for silky inertia
        this._currentX += (this._targetX - this._currentX) * 0.12;
        this.track.style.transform = 'translate3d(' + this._currentX.toFixed(2) + 'px, 0, 0)';

        this.updateProgress(p);

        // Keep ticking until settled close enough
        if (Math.abs(this._targetX - this._currentX) > 0.5) {
          this._ticking = true;
          requestAnimationFrame(this._tick);
        }
      }

      onResize() {
        if (!this.scrollMode) return;
        this.measure();
        this.tick();
      }

      onTrackScroll() {
        if (this.scrollMode) return;
        var max = this.track.scrollWidth - this.track.clientWidth;
        this.updateProgress(max > 0 ? this.track.scrollLeft / max : 0);
      }

      currentIndex() {
        var n = this.cards.length;
        if (n < 2) return 0;
        if (this.scrollMode) return Math.round(this._p * (n - 1));
        var max = this.track.scrollWidth - this.track.clientWidth;
        return max > 0 ? Math.round((this.track.scrollLeft / max) * (n - 1)) : 0;
      }

      goTo(index) {
        var n = this.cards.length;
        if (this.loop && n > 1) {
          index = (index + n) % n;
        } else {
          index = Math.max(0, Math.min(index, n - 1));
        }
        if (this.scrollMode) {
          var p = n > 1 ? index / (n - 1) : 0;
          var rect = this.getBoundingClientRect();
          var stageTopDoc = window.pageYOffset + rect.top;
          window.scrollTo({ top: stageTopDoc + p * this._total, behavior: 'smooth' });
        } else {
          var card = this.cards[index];
          if (card) this.track.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
        }
      }

      goPrev() {
        this.goTo(this.currentIndex() - 1);
      }

      goNext() {
        this.goTo(this.currentIndex() + 1);
      }

      updateProgress(p) {
        if (!this.progressFill) return;
        p = Math.max(0, Math.min(1, p));
        var n = this.cards.length || 1;
        var minPct = (1 / n) * 100;
        this.progressFill.style.width = minPct + p * (100 - minPct) + '%';

        var idx = Math.round(p * (n - 1));
        var prevDisabled = !this.loop && idx <= 0;
        var nextDisabled = !this.loop && idx >= n - 1;
        if (this.prevBtn) {
          this.prevBtn.classList.toggle('is-disabled', prevDisabled);
          this.prevBtn.disabled = prevDisabled;
        }
        if (this.nextBtn) {
          this.nextBtn.classList.toggle('is-disabled', nextDisabled);
          this.nextBtn.disabled = nextDisabled;
        }
      }
    }

    customElements.define('core-air-lifestyle', LifestyleStorySlider);
  })();
